import React from "react";
import { Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ToggleSwitch from "./ToggleSwitch";

const useStyles = makeStyles({
    root: {
        font: "normal normal normal 16px / 25px Poppins !important",
    },
});

function SlidingButton(props) {
    const {
        handleChange,
        title,
        value,
        options,
        className = "input-wrapper",
    } = props;
    const classes = useStyles();
    return (
        <Stack class={className}>
            <Typography class="title">{title}</Typography>
            <ToggleSwitch
                handleChange={handleChange}
                value={value}
                options={options}
            />
        </Stack>
    );
}

export default SlidingButton;
